import React from "react";

export default function BannerCard({
    banner,
    onClick

}) {
    return (
        <button
            className="banner-card"
            onClick={onClick}
        >
            <img
                src={`https://myd.montepio.org/${banner.image}`}
                alt={banner.title}
            />
        </button>
    );

}